import axios from 'axios';
import ReactHtmlParser from 'react-html-parser';
const voiceApi = axios.create({});
const esApi = axios.create({});

/* image 확대 */
export const imageClick = text => {
  let str1 = '';
  let str2 = '';
  let mixStr = '';
  if (text.indexOf('<img') !== -1) {
    str1 = text.indexOf('src="');
    str2 = text.indexOf('" alt="image"');
    mixStr = text.substring(str1 + 5, str2);
    const image = `<img src="${mixStr}"/>`;
    const img = new Image();
    img.src = mixStr;
    const popWidth = img.width + 20;
    const popHeight = img.height + 20;
    // 만들 팝업창 width 크기의 1/2 만큼 보정값으로 빼주었음
    const popX = window.screen.width / 2 - popWidth / 2;
    const popY = window.screen.height / 2 - popHeight / 2;

    const options = 'left=' + popX + ', top=' + popY + ', width=' + popWidth + ', height=' + popHeight + ', status=no, menubar=no, toolbar=no, resizable=no';
    const imageView = window.open('', 'imageView', options);
    imageView.document.body.innerHTML = '';
    imageView.document.write(image);
  }
};

/** 태그를 삭제하고 텍스트만 반환하는 함수
 * @param {string} textWithTag
 * @returns {string}
 */
export const removeTag = textWithTag => textWithTag.replace(/(<([^>]+)>)/gi, '');

/** 태그 하이라이트 반환하는 함수
 * @param {string} textWithTag
 * @returns {string}
 */
export const TagHighLight = textWithTag => {
  textWithTag = textWithTag.split('<EM>').join('<font class="AutoComClass" color="#1e90ff">');
  textWithTag = textWithTag.split('</EM>').join('</font>');
  return ReactHtmlParser(textWithTag);
};

/**
 * Determine the mobile operating system.
 * This function returns one of 'iOS', 'Android', 'Windows Phone', or 'unknown'.
 *
 * @returns {String}
 */
export const getMobileCheck = () => {
  const varUA = navigator.userAgent.toLowerCase();
  let device = '';
  if (varUA.indexOf('android') > -1) {
    device = 'android';
  } else if (varUA.indexOf('iphone') > -1 || varUA.indexOf('ipad') > -1 || varUA.indexOf('ipod') > -1) {
    device = 'ios';
  } else {
    device = 'other';
  }
  return device;
};

export const weBrowser = () => {
  let internet = navigator.userAgent.toLowerCase();
  console.log(internet);

  if ((navigator.appName === 'Netscape' && internet.indexOf('trident') !== -1) || internet.indexOf('msie') !== -1) {
    internet = 'ie';
  } else if (internet.indexOf(' opr/') !== -1) {
    internet = 'opr';
  } else if (internet.indexOf('chrome') !== -1) {
    internet = 'chrome';
  } else if (internet.indexOf('safari') !== -1) {
    internet = 'safari';
  } else if (internet.indexOf('firefox') !== -1) {
    internet = 'firefox';
  } else {
    internet = 'other';
  }
  console.log(internet);
  return internet;
};

export const device = () => {
  const mobile_filter_ = 'win16|win32|win64|mac|macintel';
  if (navigator.platform) {
    if (mobile_filter_.indexOf(navigator.platform.toLowerCase()) < 0) {
      return 'mo';
    }
    if (mobile_filter_.indexOf(navigator.platform.toLowerCase()) > 0) {
      return 'pc';
    }
  }
};

/* 크롬, 모질라, 파이어폭스 브라우저에서 음성 녹음이 가능한지 확인 하는 함수 */
export const hasGetUserMedia = () => {
  return !!(navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia);
};

/* 구글 STT에서 리턴받은 글자를 화면에 보여주고 멀티상담이나 뚜봇챗서버로 전송하는 함수 */
export const recordmsg = msg => {
  if (msg === 'Microphone not supported') {
    alert('모바일에서만 지원가능한 서비스입니다.');
  } else if (msg !== '') {
    console.log('사용가능');
  }

  /* 
  비워준다?
  	// $("#voice").empty();
   */
};

/* TTS */
/* 원본 andriod */
export const requestAudioFile = async  (ttstest,gen) => {
  const Context = window.AudioContext || window.webkitAudioContext;
  const audioContent = new Context();
  console.log(ttstest);
  console.log(gen);

  const res = await voiceApi.post('/Voice', {  tts: ttstest,gender:gen}, { responseType: 'arraybuffer' });
  const audioContext = audioContent;
  const audioBuffer = await audioContext.decodeAudioData(res.data);
  const source = audioContext.createBufferSource();
  source.buffer = audioBuffer;
  source.connect(audioContext.destination);
  /* 자동으로 오디오 시작되게 */
  source.start();
  console.log('source : ', source);
};

let audioCtx;
export const sendAudioCtx = audio => {
  audioCtx = audio;
  return audioCtx;
};

/* ios  */
export const requestIosAudioText = async (sttResult,gen) => {
  console.log(sttResult);
  console.log(gen);
  const res = await voiceApi.post('/Voice', { tts: sttResult,gender:gen }, { responseType: 'arraybuffer' });
  /*   const res = await voiceApi.post('/api/ics_v2/ics2_stt', {tts:ttstest}, {responseType: 'arraybuffer'}); */

  /* const arr = toArrayBuffer(res.data); */
  const audioContext = audioCtx;
  const audioBuffer = await audioContext.decodeAudioData(res.data);
  console.log(audioContext.state);
  /* create audio source */
  const source = audioContext.createBufferSource();
  source.buffer = audioBuffer;
  source.connect(audioContext.destination);
  /* 자동으로 오디오 시작되게 */
  source.start();
  console.log('source : ', source);
};

/* STT current(11/18) ios만 적용 */
export const requestSpeechText = async sendSpeech => {
  console.log(sttResult);

  const res = await voiceApi.post('/Voice', { content: sendSpeech });
  console.log(res);
};

/* 배경화면변경  */
export const requestBackground = async () => {
  try {
    let backImgName = '';
    const res = await esApi.post('/backImg');
    backImgName = res.data[0]._source.name;
    const backEle = document.getElementById('scrollToElement');
    if (backImgName === 'basic') {
      backEle.style.backgroundColor = '#D7EBFF';
      backEle.style.backgroundImage = 'none';
    } else {
      backEle.style.backgroundImage = `url(/images/backImg/${backImgName}.gif)`;
    }
    return backImgName;
  } catch (err) {
    console.error(err);
  }
};

/* notMatch , 태그 삭제 */
export const notMatchremoveTag = textWithTag => {
  console.log(textWithTag)
  let str = ''
  if(textWithTag.indexOf('<br>, ') !== -1){
    str = textWithTag.replaceAll('<br>, ', "<br>")
    
  }else{
    str = textWithTag;
  }
  return str;
}